export const SUPPLIER_SECTION_ID = 'infoSupplier'

export const CORRECTION_LETTER_FIELD_ID = 'correction-letter-field'

export const MAX_SUPPLIER_EMAILS = 3
